import { RESOLUTION_TYPES } from 'pages/WorkAssignments/components/CreateBreakdownFlow/const';

export const buildBreakdownReasonsForAssignments = (breakdown) => {
	if (!breakdown) return [];

	const reasons = [];

	if (breakdown.reason) {
		reasons.push({ reason: breakdown.reason, meta: null });
	}

	if (breakdown.deadhead) {
		const dh = breakdown.deadhead;
		const from = dh.departure?.stationDetails?.name ?? '';
		const to = dh.arrival?.stationDetails?.name ?? '';
		reasons.push({
			reason: RESOLUTION_TYPES.deadhead,
			meta: `${dh.rideNumber}: ${from} → ${to}`,
			linkTo: '/?mode=deadhead',
		});
	}

	if (breakdown.parallelRide) {
		const ride = breakdown.parallelRide;
		const stations = ride.stations ?? [];
		const from = stations[0]?.name ?? '';
		const to = stations[stations.length - 1]?.name ?? '';
		reasons.push({
			reason: RESOLUTION_TYPES.parallelRide,
			meta: `TN ${ride.tripNumber} / ${ride.lineCode}: ${from} → ${to}`,
			linkTo: ride.id ? `/details/${ride.id}` : null,
		});
	}

	if (breakdown.replacementCrewMember && !breakdown.parallelRide && !breakdown.deadhead) {
		reasons.push({
			reason: RESOLUTION_TYPES.replacementCrewMember,
			meta: breakdown.replacementCrewMember.fullName,
			linkTo: breakdown.replacementCrewMember.id
				? `/crew-management/${breakdown.replacementCrewMember.id}`
				: null,
		});
	}

	return reasons;
};

export const buildBreakdownReasonsForRideList = (breakdown) => {
	if (!breakdown) return [];

	const reasons = [];

	if (breakdown.reason) {
		reasons.push({ reason: breakdown.reason, meta: null });
	}

	if (breakdown.deadhead) {
		const dh = breakdown.deadhead;
		const fromCode = dh.departure?.stationDetails?.code ?? '';
		const fromName = dh.departure?.stationDetails?.name ?? '';
		const toCode = dh.arrival?.stationDetails?.code ?? '';
		const toName = dh.arrival?.stationDetails?.name ?? '';
		reasons.push({
			reason: RESOLUTION_TYPES.deadhead,
			meta: `${fromCode} (${fromName}) → ${toCode} - ${toName}`,
			linkTo: '/?mode=deadhead',
		});
	}

	if (breakdown.parallelRide) {
		const ride = breakdown.parallelRide;
		const stations = ride.stations ?? [];
		const fromCode = stations[0]?.code ?? '';
		const fromName = stations[0]?.name ?? '';
		const toCode = stations[stations.length - 1]?.code ?? '';
		const toName = stations[stations.length - 1]?.name ?? '';
		reasons.push({
			reason: RESOLUTION_TYPES.parallelRide,
			meta: `TN ${ride.tripNumber} / ${ride.lineCode}: ${fromCode} - ${fromName} → ${toCode} - ${toName}`,
			linkTo: ride.id ? `/details/${ride.id}` : null,
		});
	}

	if (breakdown.replacementCrewMember && !breakdown.parallelRide && !breakdown.deadhead) {
		reasons.push({
			reason: RESOLUTION_TYPES.replacementCrewMember,
			meta: breakdown.replacementCrewMember.fullName,
			linkId: breakdown.replacementCrewMember.id,
		});
	}

	return reasons;
};
